import {ShieldProduct} from 'components/ShieldProduct';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';

export const ProductShieldSuperPrice = () => {
    const productData = useAppSelector(selectProductData);

    if (!productData?.price?.isSpecPrice) {
        return null;
    }

    return <ShieldProduct text={'Спеццена'} code={'SUPER_PRICE'} />;
};
